import { LinkList, CostCodeStatus,CostCodeStatusEnum ,CostCodeTypeNames} from '@/helpers/utilities.js'
import {GetCostCodeList,SearchCostCode, CreateCostCode, UpdateCostCode, GetCostCodeListItems, UpdateCostCodeStatus, UpdateCostCodeRestore, CreateCostCodeTemplate} from '@/actions/directoryActions.js'
import CostCodeColumn from '@/components/directoryInfo/CostCode/CostCodeColumn.vue'
import Select2 from '@/components/layout/Select2.vue'
import Modal from '@/components/layout/Modal.vue'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'
import {confirmDirectoryAction} from '@/helpers/directoryStatusConfirm.js'

function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    }[char]))
}

function highlightCostCodeName(value) {
    return `<strong class="directory-status-swal__name">${escapeHtml(value || 'this cost code')}</strong>`
}

function normalizeCostCodeText(value) {
    return String(value || '').trim().toLowerCase()
}

export default {
  name : 'CostCode',
  components :{
    Modal,
    Select2,
    CostCodeColumn
  },
  mounted : async function(){
    const self = this
    self.$store.commit('setActiveLink',LinkList.COST_CODES)
    // const getCostCode = await GetCostCodeList().catch()
    // self.costCodeList = getCostCode
    self.GetItemsCostCode('',0)
  },
  methods:{
    async GenerateCostCodeTemplate(){
        this.isGenerating = true
        showDirectoryLoading(this, {
            title: 'Syncing System Template',
            description: 'Updating the system cost code template. This may take a while if there are many codes.'
        })
        try{
            const res = await CreateCostCodeTemplate()
            closeDirectoryLoading(this)

            if(res!=='OK'){
                showDirectoryError(this, {
                    description: res || 'Unable to sync system template.'
                })
                return
            }

            showDirectorySuccess(this, {
                description: 'The cost code system template has been updated successfully.'
            })
        }catch(error){
            closeDirectoryLoading(this)
            showDirectoryError(this, {
                description: error?.message || 'Unable to sync system template. Please try again.'
            })
        }finally{
            this.isGenerating = false
        }
    },
      GetItemsCostCode(id, index){
        return this.LoadCostCodeColumn(id, index, true)
      },
    //   ChangePage(page){
    //     const self = this
    //     self.page = page
    //     GetCostCodeList(self.searchVal,self.page).then((res)=>{
    //         self.costCodeList = res
    //     }).catch()
    //   },
      searchCostCodeList(search){
          return GetCostCodeList(search)
      },
      searchCostCode(search){
        return SearchCostCode(search).then((list)=>{
            if(!Array.isArray(list)){
                return []
            }

            return list.map((item)=>Object.assign({}, item, {
                categoryRemark: item.parentCount > 0 ? this.$t('Sub') : this.$t('Main')
            }))
        })
      },
      AppendCostCodeData(obj){
        this.newCostCode.parentCount = obj.parentCount
        this.newCostCode.hideType = obj.level.indexOf('.') == -1 
        this.newCostCodeParent = Object.assign({}, obj, {
            parents: Array.isArray(obj.parents) ? obj.parents.slice() : []
        })
      },
      SearchAppend(data){
        const self = this 

        self.highlighted = data._id
        let loop = Array.isArray(data.parents) ? data.parents.slice() : []
        if(loop.length!=0){
            for(let x= 0;x<loop.length;x++){
                GetCostCodeListItems(loop[x],self.costCodeStatus).then((res)=>{
                    self.dataCostCode[x +1] = res.length!=0 ? res : null
                })
            }
            self.dataCostCode.splice(loop.length)
        }else{
            self.dataCostCode.splice(1)
        }
        loop.push(data._id)
        self.dataSelected = loop
        
        
      },
      UpdateIndexSelected(index,id){
        this.dataSelected[index] = id
      },
      emptyCostCodeText(index){
        if(index===0){
            return this.$t('No cost codes found.')
        }

        if(index===1){
            return this.$t('Select a main category to view sub category.')
        }

        if(index===2){
            return this.$t('Select a sub category to view line item.')
        }

        return this.$t('No Data Found')
      },
      LoadCostCodeColumn(id, index, trimAfterLoad = false){
        const self = this

        return GetCostCodeListItems(id,self.costCodeStatus).then((res)=>{
            const list = res.length!=0 ? res : null
            self.dataCostCode[index] = list

            if(trimAfterLoad){
                self.dataCostCode.splice(index + 1)
                self.dataSelected.splice(index)
            }

            return Array.isArray(list) ? list : []
        })
      },
      FindCreatedCostCode(list, createdData){
        const createdId = createdData.id
        const createdCode = normalizeCostCodeText(createdData.costCode)
        const createdName = normalizeCostCodeText(createdData.name)

        return [...list].reverse().find((item)=>{
            if(createdId && item._id===createdId){
                return true
            }

            const itemCode = normalizeCostCodeText(item.costCode)
            const itemName = normalizeCostCodeText(item.originalName || item.name || item.costName)
            const isSameName = createdName && itemName===createdName
            const isSameCode = createdCode && itemCode===createdCode

            return isSameName && (!createdCode || isSameCode)
        })
      },
      async ShowCreatedCostCode(createData, parentData, responseData){
        const parentPath = parentData
            ? [...(Array.isArray(parentData.parents) ? parentData.parents : []), parentData._id].filter(Boolean)
            : []
        const createdData = {
            id: responseData && typeof responseData === 'object' ? responseData._id : '',
            costCode: createData.costCode,
            name: createData.name
        }

        this.highlighted = ''
        this.dataSelected = []
        this.dataCostCode = []

        const rootList = await this.LoadCostCodeColumn('', 0, false)

        if(parentPath.length===0){
            const createdMain = this.FindCreatedCostCode(rootList, createdData)

            if(createdMain){
                this.highlighted = createdMain._id
                this.dataSelected = [createdMain._id]
                await this.LoadCostCodeColumn(createdMain._id, 1, false)
                this.dataCostCode.splice(2)
                return
            }

            return
        }

        let createdColumnIndex = Math.min(parentPath.length, 2)
        for(let index = 0; index < parentPath.length && index < 2; index += 1){
            const parentId = parentPath[index]
            this.dataSelected[index] = parentId
            await this.LoadCostCodeColumn(parentId, index + 1, false)
        }

        const createdList = Array.isArray(this.dataCostCode[createdColumnIndex])
            ? this.dataCostCode[createdColumnIndex]
            : []
        const createdItem = this.FindCreatedCostCode(createdList, createdData)

        if(createdItem){
            this.highlighted = createdItem._id
            this.dataSelected[createdColumnIndex] = createdItem._id

            if(createdColumnIndex < 2){
                await this.LoadCostCodeColumn(createdItem._id, createdColumnIndex + 1, false)
                this.dataCostCode.splice(createdColumnIndex + 2)
            }
        }
      },
      async ShowUpdatedCostCode(updateData){
        const columnIndex = Number(updateData.indexCode)
        const itemId = updateData.id

        if(!itemId || Number.isNaN(columnIndex)){
            return
        }

        this.highlighted = itemId
        this.dataSelected[columnIndex] = itemId

        const currentList = Array.isArray(this.dataCostCode[columnIndex])
            ? this.dataCostCode[columnIndex]
            : []
        const currentIndex = currentList.findIndex((item)=>item._id===itemId)

        if(currentIndex!==-1){
            currentList[currentIndex] = Object.assign({}, currentList[currentIndex], {
                originalName: updateData.name,
                status: updateData.status,
                type: updateData.type
            })
        }

        if(columnIndex < 2){
            await this.LoadCostCodeColumn(itemId, columnIndex + 1, false)
            this.dataCostCode.splice(columnIndex + 2)
            this.dataSelected.splice(columnIndex + 1)
        }
      },
      OpenCreateModal(){
        const self = this
        self.newCostCode = {
            isVariation : 'false',
            parentCount : 0,
            hideType : true,
            type : 1
        }
        self.newCostCodeParent = null
        self.isClicked = false
      },
      CreateCostCodeRun(e){
        const self = this
        const btn = e.target
        const data = self.newCostCode
        self.isClicked = true

        if(!data.parent || data.parentCount ==0){
            if(!data.costCode){
                return
            }
        }
        if(!data.name){
            return
        }

        if(!data.type){
            return
        }
        
        btn.disabled = true
        showDirectoryLoading(self, {
            title: 'Creating Cost Code',
            description: 'Saving the cost code and refreshing the directory.'
        })
        const createdData = Object.assign({}, self.newCostCode)
        const parentData = self.newCostCodeParent

        CreateCostCode(self.newCostCode).then((res)=>{
            btn.disabled = false
            self.isClicked = false
            if(res=="OK" || (res && typeof res === 'object')){
                self.$refs.closeAddModal.click()
                self.ShowCreatedCostCode(createdData, parentData, res).catch(()=>{
                    self.GetAllItems()
                }).then(()=>{
                    closeDirectoryLoading(self)
                    showDirectorySuccess(self, {
                        description: 'The cost code has been created successfully and is ready to use.'
                    })
                })
            }else{
                closeDirectoryLoading(self)
                showDirectoryError(self, {
                    description: res,
                    duplicateValue: data.name
                })
            }
        }).catch((error)=>{
            btn.disabled = false
            self.isClicked = false
            closeDirectoryLoading(self)
            showDirectoryError(self, {
                description: error?.message || 'Unable to create cost code. Please try again.',
                duplicateValue: data.name
            })
        })
      },
      UpdateCostCodeRun(e){
        const self = this
        const btn = e.target
        const data = self.updateCostCode
        
        self.isClickedUpdate = true
        if(!data.id){
            return
        }
        
        if(typeof data.status==='undefined'){
            return
        }
        if(!data.name){
            return
        }

        if(!data.type){
            return
        }

        btn.disabled = true
        showDirectoryLoading(self, {
            title: 'Updating Cost Code',
            description: 'Saving the cost code changes and refreshing the directory.'
        })
        
        UpdateCostCode(data).then((res)=>{
            self.isClickedUpdate = false
            btn.disabled = false
            if(res=="OK"){
                self.$refs.closeUpdateModal.click()
                self.ShowUpdatedCostCode(data).catch(()=>{
                    self.GetAllItems()
                }).then(()=>{
                    closeDirectoryLoading(self)
                    showDirectorySuccess(self, {
                        description: 'The cost code details have been updated successfully.'
                    })
                })

            }else{
                closeDirectoryLoading(self)
                showDirectoryError(self, {
                    description: res,
                    duplicateValue: data.name
                })
            }
        }).catch((error)=>{
            self.isClickedUpdate = false
            btn.disabled = false
            closeDirectoryLoading(self)
            showDirectoryError(self, {
                description: error?.message || 'Unable to update cost code. Please try again.',
                duplicateValue: data.name
            })
        })
      },
      OpenUpdateModal(data,index){
        const self = this
        self.updateCostCode = Object.assign({},data)
        self.updateCostCode.name = self.updateCostCode.originalName
        self.updateCostCode.id = data._id
        self.updateCostCode.indexCode = index
        self.updateCostCode.isItemCostCode = data.isItemCostCode
        self.updateCostCode.type = data.type
        self.isClickedUpdate = false
        
      },
      timerSetter(typed, callback, seachEmpty = true){
        const self = this
        if(!seachEmpty){
            if(!typed){
                return
            }
        }
        
        if(self.timer){
            clearTimeout(self.timer)
            self.timer = null
        }

        self.timer = setTimeout(callback,700)
      },
      DeleteCostCodeRun(id, name){
          const self = this
          const highlightedName = highlightCostCodeName(name)

          return confirmDirectoryAction(self, {
            title: 'Remove Cost Code?',
            description: `Are you sure you want to remove ${highlightedName}? This cost code will no longer be available for use.`,
            confirmButtonText: 'Remove',
            onConfirm: () => UpdateCostCodeStatus(id).then((res)=>{
                if(res=='OK'){
                    self.GetAllItems()
                }

                return res
            }),
            successDescription: `The cost code ${highlightedName} has been removed successfully and is no longer active.`,
            errorMessage: 'Unable to remove cost code.'
        })
      },
      RestoreCostCodeRun(id, name){
        const self = this
        const highlightedName = highlightCostCodeName(name)

        return confirmDirectoryAction(self, {
          title: 'Restore Cost Code?',
          description: `Are you sure you want to restore ${highlightedName}? This cost code will be available for use again.`,
          confirmButtonText: 'Restore',
          onConfirm: () => UpdateCostCodeRestore(id).then((res)=>{
              if(res=='OK'){
                  self.GetAllItems()
              }

              return res
          }),
          successDescription: `The cost code ${highlightedName} has been restored successfully and is active again.`,
          errorMessage: 'Unable to restore cost code.'
        })
    },
      ResetSelectParent(){
        this.newCostCode.parent = ''
        this.newCostCode.parentCount = 0
        this.newCostCode.hideType = true
        this.newCostCode.type = 1
        this.newCostCodeParent = null
      },
      GetAllItems(){
        const self = this
        let refreshArray = ['']
        if(self.dataSelected.length!=0){
            if(self.dataSelected.length==3){
                refreshArray.push(...self.dataSelected.slice(0,2))
            }else{
                refreshArray.push(...self.dataSelected)
            }
        }
        for(let x = 0; x<refreshArray.length;x++){
            GetCostCodeListItems(refreshArray[x],self.costCodeStatus).then((res)=>{
                self.dataCostCode[x] = res.length!=0 ? res : null
            })
        }
        
      }
  },
  data(){
    return {
        isGenerating : false,
        CostCodeTypeNames,
        costCodeList : {
            docs: [],
            page : 1,
            totalPages : 0,
        },
        costCodeStatus : 1,
        dataCostCode : [],
        dataSelected : [],
        page : 1,
        searchVal : "",
        newCostCode :{
            isVariation : 'false',
        },
        newCostCodeParent : null,
        highlighted : '',
        CostCodeStatus : CostCodeStatus,
        updateCostCode :{},
        isClicked : false,
        isClickedUpdate : false,
        costCodeLabels :['Main Category', 'Sub Category', 'Line Item'],
        CostCodeStatusEnum : CostCodeStatusEnum
    }
  }
}
